
    <form  [autocomplete]="autocomplete"
           [className]="className"
           [formGroup]="formGroup">

      <ng-container *ngFor="let controlModel of formModel;"
                    dynamicControl [formGroup]="formGroup"
                    [model]="controlModel"
                    (customEvent)="onCustomEvent($event)">
      </ng-container>

    </form>
  